module.exports = __webpack_public_path__ + "img/target-icon.d2f33467.svg";